<template>
  <div id="basketball_recordDataOverview" v-show="currThemeObj">
    <div class="teamList_area">
      <div
        class="groupData_item"
        v-for="group in groupList"
        :key="group.groupType"
      >
        <div class="group_label">
          <span class="labelTitle" v-text="group.groupTitle"></span>
          <span
            class="moreBtn"
            @click="goMore(group.morePathName)"
            v-text="'更多数据 >'"
          ></span>
        </div>
        <div class="tab_box">
          <div class="tab_area">
            <span class="themeType_changeArea">
              <span
                class="themeType_item"
                v-for="item in group.tabArr"
                :key="item.id"
                :class="item.act ? 'act' : ''"
                v-text="item.name"
                @click="changeTab(group, item.id)"
              ></span>
            </span>
          </div>
        </div>
        <cup_notData
          v-if="group.isNotDataFlag"
          className="relativePtb30"
        ></cup_notData>
        <template v-else>
          <cup_cardList
            :currThemeObj="currThemeObj"
            :currCid="currCid"
            :currSid="currSid"
            :list="group.dataList"
            :mode="group.groupType"
            @clickPublishEvent="clickPublish"
          >
            <template v-slot:overviewTeamData="{ datas }">
              <span
                class="cardItem_row"
                :class="group.groupType"
                v-for="item in datas"
                :key="item.id"
                @click="goDetail(group, item)"
              >
                <span class="rankNo" v-text="item.rank"></span>
                <span class="cardItem_row_image">
                  <img :src="item.imageUrl" />
                </span>
                <span class="cardItem_row_name" v-text="item.shortName"></span>
                <span class="cardItem_row_val" v-text="item.val"></span>
              </span>
            </template>

            <template v-slot:overviewPlayerData="{ datas }">
              <span
                class="cardItem_row"
                :class="group.groupType"
                v-for="item in datas"
                :key="item.id"
                @click="goDetail(group, item)"
              >
                <span class="rankNo" v-text="item.rank"></span>
                <span class="cardItem_row_image">
                  <img :src="item.imageUrl" />
                </span>
                <span class="cardItem_row_center">
                  <span
                    class="cardItem_row_name"
                    v-text="item.shortName"
                  ></span>
                  <span
                    class="cardItem_row_teamName"
                    v-text="item.teamName"
                  ></span>
                </span>
                <span class="cardItem_row_val" v-text="item.val"></span>
              </span>
            </template>
          </cup_cardList>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { https_package_getDataOverviewByType } from '@api/platfrom_basketball_api'
import cup_base_data_mixin from '@mixins/cup_base_data'
import cup_cardList from '@components/platfromBase/football/cup_cardList.vue'
import cup_notData from '@components/base/NO_DATA.vue'
// import { https_package_findAnalysisItem } from '@api/platfrom_base_api'
import single_findAnalysisItem_data_mixin from '@mixins/single_findAnalysisItem_data'
export default {
  name: 'basketball_recordDataOverview',
  mixins: [cup_base_data_mixin, single_findAnalysisItem_data_mixin],
  components: {
    cup_cardList,
    cup_notData,
  },
  props: {
    crossSeason: {
      type: Boolean,
      default: true, // 默认联赛
    },
    phaseArr: {
      type: Array,
      default: () => {
        // 默认返回联赛的
        return [
          {
            phaseId: '1',
            phaseName: '常规赛',
          },
          {
            phaseId: '2',
            phaseName: '季后赛',
          },
          {
            phaseId: '9',
            phaseName: '保级赛',
          },
        ]
      },
    },
  },
  data() {
    return {
      groupList: [
        {
          themeTemplateType: 20,
          groupTitle: '球员数据',
          curTabId: 'today',
          //   groupType: 'overviewTeamData', //测试,
          groupType: 'overviewPlayerData', //正式调试换成这个,
          morePathName: 'CBARecordDetailPlayerData',
          itemDetailPathName: 'CBAPlayerDetailIndex',
          tabArr: [
            {
              name: '今日最佳',
              id: 'today',
              act: true,
            },
            {
              name: '昨日最佳',
              id: 'yesterday',
              act: false,
            },
            {
              name: '赛季最佳',
              id: 'season',
              act: false,
            },
          ],
          orginDataList: null,
          dataList: null,
          themeItem: null,
        },
        {
          themeTemplateType: 22,
          curTabId: 'today',
          groupTitle: '球队数据',
          groupType: 'overviewTeamData',
          morePathName: 'recordDetailTeamData',
          itemDetailPathName: 'teamDetailIndex',
          tabArr: [
            {
              name: '今日最佳',
              id: 'today',
              act: true,
            },
            {
              name: '昨日最佳',
              id: 'yesterday',
              act: false,
            },
            {
              name: '赛季最佳',
              id: 'season',
              act: false,
            },
          ],
          orginDataList: null,
          dataList: null,
          themeItem: null,
        },
      ], // 22、球队数据；20、球员数据
    }
  },
  created() {
    if (this.currThemeObj) {
      const moduleRouteNameEn = this.currThemeObj.moduleRouteNameEn
      this.morePathName = `recordDetailTeamData_${moduleRouteNameEn}`
      this.itemDetailPathName = `teamDetailIndex_${moduleRouteNameEn}`
    }
    this.init()
  },
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      for (let i = 0; i < this.groupList.length; i++) {
        const group = this.groupList[i]
        await this.getDataOverviewByType({
          templateType: group.themeTemplateType,
          cid: this.currCid,
          sid: this.crossSeason ? 0 : this.currSid,
        })
        this.changeTab(group, group.curTabId)
        this.makeAnalysisItemParams(group.themeTemplateType)
      }
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    makeAnalysisItemParams(themeTemplateType) {
      // 每个页面单独设置不同函数
      console.debug('makeAnalysisItemParams')
      this.findAnalysisItemParams = {
        sportType: 'basketball',
        templateType: themeTemplateType,
        cid: this.currCid,
        sid: this.crossSeason ? 0 : this.currSid,
        did: 0,
        eid: 0,
        pid: 0,
        mid: 0,
      }
      if (this.initSingleFindAnalysisItem) {
        this.initSingleFindAnalysisItem(this.findAnalysisItemParams)
      }
      // let { num } = this.paramsChangeObj
      // this.paramsChangeObj = {
      //   type: 'reset',
      //   num: num + 1,
      // }
    },
    findAnalysisItemCallback(resData) {
      // 主题数据和主题分析项分开，分析项有数据后展示分享按钮
      let jsonArr = []
      if (resData && resData.length > 0) {
        resData.forEach((item) => {
          this.groupList.forEach((group) => {
            if (group.themeTemplateType === item.templateType) {
              jsonArr.push(item.json)
              item.actJson = JSON.parse(item.json)
              item.renderData = null
              group.themeItem = item
            }
          })
        })
        // this.themeList = resData.map((item) => {
        //   jsonArr.push(item.json)
        //   item.actJson = JSON.parse(item.json)
        //   item.renderData = null
        //   return item
        // })
      }
      // else {
      //   this.themeList = []
      //   this.themeItem = null
      // }
    },
    clickPublish(item) {
      let themeItem = item.themeItem
      this.groupList.forEach((group) => {
        if (group.themeItem.analysisItemId === item.themeItem.analysisItemId) {
          themeItem = Object.assign(group.themeItem, item.themeItem)
        }
      })
      console.debug('点击分享', item, themeItem)
      this.clickPublicTheme(themeItem)
    },
    // clickPublicTheme(themeItem) {
    //   // 分享主题
    //   let newThemeItem = themeItem
    //   console.debug('newThemeItem:', newThemeItem)
    //   if (!newThemeItem.analysisItemName) {
    //     // 有的主题有analysisItemName，有的没有，比如积分榜，因此处理一下，分享主题到公共播单的接口dataItemName都取这个字段
    //     newThemeItem.analysisItemName = newThemeItem.title
    //   }
    //   window.mixtmtBase_eventBus.$emit('publicThemeDialogEvent', {
    //     flag: true,
    //     themeItem: newThemeItem,
    //     mid: 0,
    //   })
    // },
    changeTab(group, curTabId) {
      console.debug(group)
      if (group.orginDataList) {
        group.tabArr.forEach((tab, tabIndex) => {
          if (tab.id === curTabId) {
            tab.act = true
            group.dataList = group.orginDataList[tabIndex]
            group.isNotDataFlag = group.isNotDataFlagArr[tabIndex]
          } else {
            tab.act = false
          }
        })
      }
    },
    async getDataOverviewByType(query) {
      await https_package_getDataOverviewByType(
        this.axiosBaseUrl,
        this.$axios,
        query
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            let groupList = this.groupList
            groupList.forEach((groupItem) => {
              if (query.templateType == groupItem.themeTemplateType) {
                let isNotDataFlag = true
                groupItem.isNotDataFlagArr = []
                groupItem.orginDataList = res.data
                  ? res.data.map((themeGroup) => {
                      let newThemeGroup = themeGroup.map((val, valInd) => {
                        console.debug('this.groupList:', val.data)
                        if (val.data.dataList && val.data.dataList.length > 0) {
                          isNotDataFlag = false
                        }
                        return {
                          analysisItemId: val.analysisItemId,
                          title: val.title,
                          key: `${val.templateId}_${valInd}`,
                          actJson: JSON.parse(val.json),
                          json: val.json,
                          seasonOrMatch: val.seasonOrMatch,
                          crossSeason: val.crossSeason,
                          datas: val.data.dataList.map((item) => {
                            if (groupItem.themeTemplateType === 20) {
                              // 球员
                              return {
                                imageUrl: item.playerLogo,
                                pid: item.playerId,
                                shortName: item.playerName,
                                val: item.num,
                                rank: item.rank,
                                tid: item.teamId,
                                teamName: item.teamName,
                              }
                            } else if (groupItem.themeTemplateType === 22) {
                              // 球队
                              return {
                                imageUrl: item.teamLogo,
                                tid: item.teamId,
                                shortName: item.teamName,
                                val: item.num,
                                rank: item.rank,
                              }
                            } else {
                              return {}
                            }
                          }),
                          useScene: val.useScene,
                        }
                      })
                      groupItem.isNotDataFlagArr.push(isNotDataFlag)
                      return newThemeGroup
                    })
                  : []
              }
            })
            this.groupList = groupList
            console.debug('this.groupList:', this.groupList)
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    goDetail(group, item) {
      if (group.groupType == 'overviewPlayerData') {
        this.pageJump(this.$router, routeName, {
          cid: this.currCid,
          sid: this.currSid,
          tid: item.tid,
          pid: item.pid,
        })
      } else if (group.groupType == 'overviewTeamData') {
        this.$localStorage.setItem(
          'mixtmt_teamDetail',
          JSON.stringify({
            teamName: item.shortName,
            teamLogo: item.imageUrl,
            teamId: item.tid,
          })
        )
        this.pageJump(this.$router, group.itemDetailPathName, {
          cid: this.currCid,
          sid: this.currSid,
          tid: item.tid,
        })
      } else {
      }
    },
    goMore(routeName) {
      this.pageJump(this.$router, routeName)
    },
  },
}
</script>

<style lang="scss" scoped>
#basketball_recordDataOverview {
  .teamList_area {
    width: 100%;
    padding-bottom: 3.472vw;
    .groupData_item {
      padding-top: 2.083vw;
      .group_label {
        position: relative;
        width: 100%;
        height: 3.472vw;
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: center;
        .labelTitle {
          width: 50%;
          font-size: 1.389vw;
          color: var(--mixtmt_greyColor3);
          text-align: left;
          font-weight: bold;
        }
        .moreBtn {
          width: auto;
          font-size: 0.972vw;
          line-height: 1.388vw;
          transition: transform 0.3s linear;
          color: var(--mixtmt_greyColor2);
          text-align: right;
        }
      }
      .tab_box {
        width: 100%;
        .tab_area {
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          width: 100%;
          height: 3.47vw;
          background-color: var(--mixtmt_greyColor8);
          .themeType_changeArea {
            flex: 1;
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            border: 1px solid var(--mixtmt_greyColor7);
            /* border-color: var(--mixtmt_greyColor7); */
            border-radius: 0.278vw;
            .themeType_item {
              width: 100%;
              line-height: calc(3.47vw - 2px);
              text-align: center;
              color: var(--mixtmt_greyColor2);
              font-size: 0.972vw;
              border-left: 1px solid var(--mixtmt_greyColor7);
              border-right: 1px solid var(--mixtmt_greyColor7);
              &.act {
                background-color: var(--mixtmt_mainColor8);
                color: var(--mixtmt_whiteColor);
                &:first-child {
                  border-radius: 0.278vw 0 0 0.278vw;
                }
                &:last-child {
                  border-radius: 0 0.278vw 0.278vw 0;
                }
              }
              &:first-child,
              &:last-child {
                border: 0;
              }
            }
          }
        }
      }
    }
  }
}
.mixtmt_pc #basketball_recordDataOverview,
.mixtmt_ipad #basketball_recordDataOverview {
}
.mixtmt_pc #basketball_recordDataOverview {
  .teamList_area {
    .tab_area {
      .themeType_changeArea {
        .themeType_item {
          cursor: pointer;
          &:hover {
            background-color: var(--mixtmt_mainColor8);
            color: var(--mixtmt_whiteColor);
            &:first-child {
              border-radius: 0.278vw 0 0 0.278vw;
            }
            &:last-child {
              border-radius: 0 0.278vw 0.278vw 0;
            }
          }
        }
      }
    }
    .groupData_item {
      .group_label {
        .moreBtn {
          cursor: pointer;
          &:hover {
            transform: translateX(-0.208vw);
            color: var(--mixtmt_subColor1_1);
          }
        }
      }
    }
  }
}
</style>
